module.exports = __webpack_public_path__ + "media/cyclist.8c0295b2.webm";